
import { useState, useCallback, useEffect } from 'react';
import { Quote } from '../data/quotesInterface';
import { logAnalyticsEvent } from '@/lib/analytics';
import { getRandomQuote, getFilteredQuotes } from '@/lib/quoteAPIHelper';

interface RandomQuoteResult {
  quote: Quote;
  image: string;
  refreshQuote: () => Promise<{ quote: Quote; image: string }>;
  selectedCategories: string[];
  setSelectedCategories: (categories: string[]) => void;
  selectedAuthors: string[];
  setSelectedAuthors: (authors: string[]) => void;
}

export const useRandomQuote = (): RandomQuoteResult => {
  const [selectedCategories, setSelectedCategories] = useState<string[]>(["All"]);
  const [selectedAuthors, setSelectedAuthors] = useState<string[]>([]);

  const [currentQuote, setCurrentQuote] = useState<Quote>();
  const [currentImage, setCurrentImage] = useState<string>();
  let firstLoad: boolean = true;
  // Update the quote when filters change
  useEffect(() => {
    if (!firstLoad) {
      firstLoad = false;
      return;
    }
    // const fetchRandomQuote = async () => {
    //   const randomQuote = await getRandomQuote();
    //   setCurrentQuote(randomQuote);
    //   setCurrentImage(randomQuote.image);
    // };
    // fetchRandomQuote();
  }, [selectedCategories, selectedAuthors]);

  const refreshQuote = useCallback(async (): Promise<{ quote: Quote; image: string }> => {
      const quote = await getFilteredQuotes(selectedCategories, selectedAuthors, "", 1, true).then(quotes => quotes.quotes[0]);
      setCurrentQuote(quote);
      setCurrentImage(quote.image);
    logAnalyticsEvent('refresh');
    return { quote, image: quote.image };
  }, [selectedCategories, selectedAuthors]);

  // Handle category changes
  const handleCategoriesChange = useCallback((categories: string[]) => {
    setSelectedCategories(categories);
  }, []);

  // Handle author changes
  const handleAuthorsChange = useCallback((authors: string[]) => {
    setSelectedAuthors(authors);
  }, []);

  return {
    quote: currentQuote,
    image: currentImage,
    refreshQuote,
    selectedCategories,
    setSelectedCategories: handleCategoriesChange,
    selectedAuthors,
    setSelectedAuthors: handleAuthorsChange,
  };
};
